import { SupportLink, type SupportLinkProps } from "@/modules/support/SupportLink.tsx";
import { Trans } from "@lingui/react/macro";

export function ContactSupportButton(props: Omit<SupportLinkProps, "children">) {
    return (
        <SupportLink color="primary" isButton {...props}>
            <Trans>Contact support</Trans>
        </SupportLink>
    );
}
